import { createPortal } from 'react-dom'

interface Props {
  message: string
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmModal({ message, onConfirm, onCancel }: Props) {
  return createPortal(
    <div className="fixed inset-0 z-[99999] flex items-center justify-center" onClick={onCancel}>
      <div className="absolute inset-0 bg-ink/40" />
      <div
        className="relative w-[22rem] bg-paper border border-frame rounded p-lg shadow-page"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="font-body text-sm text-ink m-0">{message}</p>
        <div className="flex justify-end gap-sm mt-lg">
          <button
            onClick={onCancel}
            className="px-md py-xs font-label text-sm text-ink-light border border-frame rounded bg-transparent cursor-pointer hover:bg-desk transition-colors"
          >
            Anuluj
          </button>
          <button
            onClick={onConfirm}
            className="px-md py-xs font-label text-sm text-paper bg-danger border-none rounded cursor-pointer hover:brightness-110 transition-[filter]"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
